module.exports = __webpack_public_path__ + "static/media/img_sendero.6d54f75c.jpg";